// Configuraciones de tours guiados para diferentes perfiles de usuario

export const supervisorTour = [
  // 1. Bienvenida
  {
    target: '.main-content',
    title: '¡Bienvenido a Trazalogis WMS!',
    description: 'Te guiaremos paso a paso por todas las funcionalidades del sistema. Como supervisor, tendrás acceso completo a todas las herramientas de gestión.',
    action: (router) => {
      // Asegurar que estamos en la página principal
      if (router && router.currentRoute.value.path !== '/analytics') {
        router.push('/analytics')
      }
    }
  },

  // 2. Navegación - Sidebar
  {
    target: '.sidebar',
    title: 'Panel de Navegación',
    description: 'Desde aquí puedes acceder a todas las secciones del sistema. Como supervisor, tienes acceso a Analytics, Gestión de Órdenes, Inventario, Usuarios y más.',
  },

  // 3. Gestión de Usuarios - Primer paso
  {
    target: '[href="/users"]',
    title: 'Gestión de Usuarios',
    description: 'Ahora navegaremos automáticamente a la sección de Gestión de Usuarios donde podrás crear y administrar usuarios de tu equipo. Esta es la base para configurar los permisos y roles de tu equipo.',
    action: (router) => {
      // Navegar a usuarios automáticamente usando Vue Router
      if (router && router.currentRoute.value.path !== '/users') {
        router.push('/users')
      }
    }
  },

  // 4. Crear Usuario
  {
    target: '.create-user-btn, [data-tour="create-user"]',
    title: 'Crear Nuevo Usuario',
    description: 'Aquí puedes agregar nuevos miembros a tu equipo. Haz clic en el botón "Nuevo Usuario" para agregar un usuario y asignarle un rol específico como operario, supervisor o visualizador.',
  },

  // 5. Instalaciones - Bodegas
  {
    target: '[href="/instalaciones"]',
    title: 'Configurar Instalaciones',
    description: 'Ahora navegaremos automáticamente a la sección de Instalaciones para configurar las bodegas y zonas de almacenamiento. Esto es fundamental para organizar tu inventario de manera eficiente.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/instalaciones') {
        router.push('/instalaciones')
      }
    }
  },

  // 6. Crear Bodega
  {
    target: '.create-warehouse-btn, [data-tour="create-warehouse"]',
    title: 'Crear Nueva Bodega',
    description: 'En esta página puedes gestionar tus bodegas. Haz clic en el botón "Crear Bodega" o "Nueva Bodega" para agregar tu primera instalación. Aquí definirás el nombre, ubicación y características principales del almacén.',
  },

  // 7. Crear Zona
  {
    target: '.create-zone-btn, [data-tour="create-zone"]',
    title: 'Crear Zonas de Almacenamiento',
    description: 'Dentro de cada bodega, puedes crear zonas específicas para organizar mejor tus productos. Haz clic en "Crear Zona" para agregar áreas como Zona A, Zona B, Refrigerados, etc.',
  },

  // 8. Gestión de Inventario
  {
    target: '[href="/inventario"]',
    title: 'Gestión de Inventario',
    description: 'Navegaremos automáticamente a la sección más importante: el inventario. Aquí podrás crear productos, categorías y controlar todo tu stock.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/inventario') {
        router.push('/inventario')
      }
    }
  },

  // 9. Crear Categoría
  {
    target: '.create-category-btn, [data-tour="create-category"]',
    title: 'Crear Categorías',
    description: 'Primero crea categorías para organizar tus productos (ej: Electrónicos, Ropa, Alimentos, etc.). Haz clic en el botón correspondiente para crear una nueva categoría.',
  },

  // 10. Crear Producto
  {
    target: '.create-product-btn, [data-tour="create-product"]',
    title: 'Crear Nuevo Producto',
    description: 'Agrega tu primer producto al inventario. Define nombre, SKU, categoría, dimensiones y otros atributos importantes. Haz clic en "Nuevo Producto" para comenzar.',
  },

  // 11. Ingresos
  {
    target: '[href="/ingresos"]',
    title: 'Registrar Ingresos',
    description: 'Navegaremos automáticamente a la sección de Ingresos para registrar la entrada de mercancía a tu bodega. Esto actualizará automáticamente el inventario.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/ingresos') {
        router.push('/ingresos')
      }
    }
  },

  // 12. Crear Ingreso
  {
    target: '.create-ingreso-btn, [data-tour="create-ingreso"]',
    title: 'Nuevo Ingreso de Mercancía',
    description: 'Registra la entrada de productos. Selecciona el producto, cantidad, ubicación y otros detalles del ingreso. Haz clic en "Nuevo Ingreso" para comenzar.',
  },

  // 13. Gestión de Órdenes
  {
    target: '[href="/orders"]',
    title: 'Gestión de Órdenes',
    description: 'Navegaremos automáticamente a la sección de Órdenes para administrar las órdenes de salida de mercancía. Aquí puedes crear, asignar y hacer seguimiento de los pedidos.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/orders') {
        router.push('/orders')
      }
    }
  },

  // 14. Crear Orden
  {
    target: '.create-order-btn, [data-tour="create-order"]',
    title: 'Crear Nueva Orden',
    description: 'Crea una orden de salida. Selecciona el cliente, productos y cantidades requeridas. Haz clic en "Nueva Orden" para comenzar.',
  },

  // 15. Asignación de Picking
  {
    target: '[href="/picking-assignment"]',
    title: 'Asignación de Picking',
    description: 'Navegaremos automáticamente a la sección de Asignación de Picking para asignar las tareas de recolección a tus operarios. Esto optimiza el proceso de preparación de pedidos.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/picking-assignment') {
        router.push('/picking-assignment')
      }
    }
  },

  // 16. Asignar Tarea
  {
    target: '.assign-picking-btn, [data-tour="assign-picking"]',
    title: 'Asignar Tarea de Picking',
    description: 'Selecciona una lista de picking y asígnala a un operario disponible. El sistema calculará la ruta óptima. Haz clic en "Asignar" para completar la asignación.',
  },

  // 17. Gestión de Costos
  {
    target: '[href="/cost-management"]',
    title: 'Gestión de Costos',
    description: 'Navegaremos automáticamente a la sección de Gestión de Costos para controlar los costos de tus productos y analizar la rentabilidad del inventario.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/cost-management') {
        router.push('/cost-management')
      }
    }
  },

  // 18. Analytics y Reportes
  {
    target: '[href="/analytics"]',
    title: 'Analytics y Reportes',
    description: 'Navegaremos automáticamente a la sección de Analytics para visualizar métricas importantes, KPIs y reportes detallados de tu operación.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/analytics') {
        router.push('/analytics')
      }
    }
  },

  // 19. Trazabilidad
  {
    target: '[href="/trazabilidad"]',
    title: 'Trazabilidad',
    description: 'Navegaremos automáticamente a la sección de Trazabilidad para rastrear el historial completo de movimientos de cualquier producto en tu bodega.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/trazabilidad') {
        router.push('/trazabilidad')
      }
    }
  },

  // 20. Finalización
  {
    target: '.main-content',
    title: '¡Tour Completado!',
    description: '¡Excelente! Has completado el tour del sistema. Ahora estás listo para gestionar tu bodega de manera eficiente. Recuerda que puedes acceder a este tour nuevamente desde el menú de ayuda.',
  }
]

export const operatorTour = [
  // 1. Bienvenida
  {
    target: '.main-content',
    title: '¡Bienvenido Operario!',
    description: 'Te mostraremos cómo usar las herramientas principales para tus tareas diarias de picking y gestión de inventario.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/operator') {
        router.push('/operator')
      }
    }
  },

  // 2. Dashboard del Operario
  {
    target: '.operator-header',
    title: 'Tu Dashboard Personal',
    description: 'Aquí puedes ver tu información personal y el resumen de tus tareas asignadas.',
  },

  // 3. Tareas Asignadas
  {
    target: '.tasks-summary, [data-tour="tasks-summary"]',
    title: 'Resumen de Tareas',
    description: 'Visualiza cuántas tareas tienes pendientes, en progreso y completadas. Este es tu centro de control diario.',
  },

  // 4. Lista de Picking
  {
    target: '.picking-list-table, [data-tour="picking-list"]',
    title: 'Lista de Tareas de Picking',
    description: 'Aquí aparecen todas las tareas de recolección que te han sido asignadas. Puedes ver el estado y detalles de cada una.',
  },

  // 5. Iniciar Picking
  {
    target: '.start-picking-btn, [data-tour="start-picking"]',
    title: 'Iniciar Tarea de Picking',
    description: 'Haz clic en "Iniciar" para comenzar una tarea de picking. El sistema te guiará por la ruta óptima.',
  },

  // 6. Detalles de Picking
  {
    target: '.picking-items, [data-tour="picking-items"]',
    title: 'Items a Recolectar',
    description: 'Aquí ves todos los productos que debes recolectar, sus ubicaciones y cantidades requeridas.',
  },

  // 7. Marcar Item Completado
  {
    target: '.complete-item-btn, [data-tour="complete-item"]',
    title: 'Completar Item',
    description: 'Cuando recolectes un producto, márcalo como completado. Puedes ajustar la cantidad si es necesario.',
  },

  // 8. Consulta de Inventario
  {
    target: '[href="/inventario"]',
    title: 'Consultar Inventario',
    description: 'Navegaremos automáticamente a la sección de Inventario para que puedas consultar el inventario y verificar ubicaciones y disponibilidad de productos.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/inventario') {
        router.push('/inventario')
      }
    }
  },

  // 9. Búsqueda de Productos
  {
    target: '.search-input, [data-tour="search-products"]',
    title: 'Buscar Productos',
    description: 'Usa la búsqueda para encontrar rápidamente productos por nombre, SKU o código de barras.',
  },

  // 10. Información del Producto
  {
    target: '.product-details, [data-tour="product-info"]',
    title: 'Detalles del Producto',
    description: 'Aquí puedes ver toda la información del producto: ubicación, stock disponible, dimensiones, etc.',
  },

  // 11. Completar Picking
  {
    target: '.complete-picking-btn, [data-tour="complete-picking"]',
    title: 'Finalizar Picking',
    description: 'Cuando hayas recolectado todos los items, completa la tarea de picking. Esto notificará al supervisor.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/operator') {
        router.push('/operator')
      }
    }
  },

  // 12. Historial de Tareas
  {
    target: '.completed-tasks, [data-tour="task-history"]',
    title: 'Historial de Tareas',
    description: 'Revisa las tareas que has completado anteriormente y tu rendimiento.',
  },

  // 13. Estadísticas Personales
  {
    target: '.operator-stats, [data-tour="operator-stats"]',
    title: 'Tus Estadísticas',
    description: 'Monitorea tu productividad: tareas completadas, tiempo promedio, eficiencia, etc.',
  },

  // 14. Finalización
  {
    target: '.main-content',
    title: '¡Tour Completado!',
    description: '¡Perfecto! Ahora conoces todas las herramientas para realizar tus tareas de manera eficiente. ¡A trabajar!',
  }
]

export const viewerTour = [
  // 1. Bienvenida
  {
    target: '.main-content',
    title: 'Bienvenido Visualizador',
    description: 'Como visualizador, puedes consultar información y reportes del sistema sin realizar modificaciones.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/analytics') {
        router.push('/analytics')
      }
    }
  },

  // 2. Analytics
  {
    target: '.analytics-dashboard',
    title: 'Dashboard de Analytics',
    description: 'Visualiza métricas importantes, KPIs y el estado general de la operación.',
  },

  // 3. Consulta de Órdenes
  {
    target: '[href="/orders"]',
    title: 'Consultar Órdenes',
    description: 'Navegaremos automáticamente a la sección de Órdenes para que puedas ver el estado de todas las órdenes y su progreso.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/orders') {
        router.push('/orders')
      }
    }
  },

  // 4. Consulta de Inventario
  {
    target: '[href="/inventario"]',
    title: 'Consultar Inventario',
    description: 'Navegaremos automáticamente a la sección de Inventario para que puedas revisar el stock disponible, ubicaciones y detalles de productos.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/inventario') {
        router.push('/inventario')
      }
    }
  },

  // 5. Trazabilidad
  {
    target: '[href="/trazabilidad"]',
    title: 'Trazabilidad',
    description: 'Navegaremos automáticamente a la sección de Trazabilidad para que puedas consultar el historial de movimientos y trazabilidad de productos.',
    action: (router) => {
      if (router && router.currentRoute.value.path !== '/trazabilidad') {
        router.push('/trazabilidad')
      }
    }
  },

  // 6. Finalización
  {
    target: '.main-content',
    title: 'Tour Completado',
    description: 'Ahora puedes navegar y consultar toda la información disponible en el sistema.',
  }
]

// Función para obtener el tour según el rol del usuario
export function getTourByRole(userRole) {
  switch (userRole) {
    case 'admin':
      return supervisorTour
    case 'operator':
      return operatorTour
    case 'viewer':
      return viewerTour
    default:
      return supervisorTour
  }
}

// Función para verificar si el usuario ya completó el tour
export function hasCompletedTour(userRole) {
  return localStorage.getItem(`tour-completed-${userRole}`) === 'true'
}

// Función para marcar el tour como completado
export function markTourAsCompleted(userRole) {
  localStorage.setItem(`tour-completed-${userRole}`, 'true')
}

// Función para resetear el tour (útil para testing)
export function resetTour(userRole) {
  localStorage.removeItem(`tour-completed-${userRole}`)
} 